import style from "./App.module.scss"
import Footer from "./components/Footer/Footer";
import Main from "./components/Main/Main";
import Navbar from "./components/Navbar/Navbar";

function App() {
  return (
    <div className={style.App}>
      <Navbar />
      <Main />
      <Footer />
    </div>
  );
}

export default App;
